import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { EventInfoWithConsentResponse, SlotResponse } from '@ent-regis/entregis-ts-angular';

@Component({
  selector: 'app-investor-time',
  templateUrl: './investor-time.component.html',
  styleUrls: ['./investor-time.component.scss']
})
export class InvestorTimeComponent implements OnChanges {

  @Input() form!: FormGroup;
  @Input() eventInfoWithConsent!: EventInfoWithConsentResponse;
  @Input() isClosedRegis: boolean = false;
  @Output() onSuccessEvent = new EventEmitter<any>();

  public now = new Date();
  investorSlots: SlotResponse[] = [];
  eventTypeEnum = EventInfoWithConsentResponse.EventTypeEnum;

  get slotsFormArray(): FormArray {
    return this.form.get('slots') as FormArray;
  }
  
  get eventType(): EventInfoWithConsentResponse.EventTypeEnum {
    return this.eventInfoWithConsent ? this.eventInfoWithConsent.eventType : null;
  }

  get isThailandFocus(): boolean {
    return this.eventInfoWithConsent && this.eventInfoWithConsent.eventType === this.eventTypeEnum.THAILANDFOCUS;
  }

  get timezone(): string {
    return this.isThailandFocus ? 'UTC +7' : null;
  }

  onSubmit() {
    if (this.isClosedRegis) {
      return;
    }
    this.onSuccessEvent.emit(this.form.value);
  }

  changeIsAvalable(form: AbstractControl) {
    if (this.isClosedRegis || form.disabled) {
      return;
    }
    form.setValue(!form.value);
  }

  toggleSelectAll(slot: any, checked: boolean) {
    if (this.isClosedRegis) {
      return;
    }

    const periods = slot.controls.slotPeriods.controls;
    periods.forEach(p => p.controls.isAvailable.setValue(checked));
  }

  isAllSelected(slot: any): boolean {
    const periods = slot.controls.slotPeriods.controls;
    return periods.every(p => p.controls.isAvailable.value);
  }

  ngOnChanges(): void {
    this.updateFormState();
  }

  private updateFormState(): void {
    if (!this.form) {
      return;
    }

    if (this.isClosedRegis) {
      this.form.disable({ emitEvent: false });
      return;
    }

    this.form.enable({ emitEvent: false });
  }


}
